// Third party libraries
import _ from 'lodash';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';

// Components
import { Button, Form } from 'semantic-ui-react';
import CustomInput from '../../../../../components/form/input';
import Select from '../../../../../components/form/Select';
import CustomDatePicker from '../../../../../components/form/datepicker';

// Validations
import { required } from '../../../../../../config/validations';

// Redux
import { closeLoader, openLoader } from "../../../../../../redux-store/loader";
import { openModal, closeModal } from '../../../../../../redux-store/modal';

// Models
import PaymentModel from '../../../../../../data/models/payment/payment';

// Locales
import I18n from '../../../../../../i18n';

const offerTypeOptions = [
    {
        key: 1,
        text: "Mensual",
        value: 'monthly'
    }, {
        key: 2,
        text: "Anual",
        value: 'annual'
    }
]

class GeneralOfferForm extends Component {

    onSubmit = async data => {

        const tempForm = { ...data };
        const self = this;

        const plan = this.props.plan;

        const message = {
            headerTitle: "Error",
            title: '',
            buttons: [{
                text: I18n.t('actions.accept'),
                callback: () => self.props.closeModal()
            }]
        };

        if (!plan) return this.props.openModal(message);

        tempForm.discount = parseInt(tempForm.discount);
        tempForm.planId = plan._id;

        if (plan.stripeCouponId) {
            tempForm.stripeCouponId = plan.stripeCouponId;
        }

        if (tempForm.discount <= 0) {

            try {

                this.props.openLoader();

                await PaymentModel.deleteProPlanGeneralOffer(self.props.offerId);

            } catch (error) {

                message.title = I18n.t('practice.anErrorOcurred') + ' ' + _.get(error, 'error', error);
                this.props.openModal(message);

            } finally {

                this.props.closeLoader();

            }

            return;
        }

        try {

            this.props.openLoader();

            await PaymentModel.createProPlanGeneralOffer(tempForm);

        } catch (error) {

            message.title = I18n.t('practice.anErrorOcurred') + ' ' + _.get(error, 'error', error);
            this.props.openModal(message);

        } finally {

            this.props.closeLoader();

        }

    }

    render() {

        return (
            <Form noValidate onSubmit={this.props.handleSubmit(this.onSubmit)}>
                <Form.Group className="general_offers_inputs">
                    <Field
                        component={CustomInput}
                        placeholder={I18n.t('plans.discount')}
                        name="discount"
                        label={I18n.t('plans.discount')}
                        validate={[required]}
                        type='number'
                        restrictions={[{ numeric: true, canBeFloat: false }]}
                    />
                    <Field
                        component={Select}
                        name="type"
                        placeholder={I18n.t('plans.offerType')}
                        label={I18n.t('plans.offerType')}
                        defaultValue={'monthly'}
                        options={offerTypeOptions}
                        style={{ marginRight: '2rem' }}
                    />
                    <Field
                        component={CustomDatePicker}
                        name="expirationDate"
                        label={I18n.t('plans.offerExpirationDate')}
                        formatDate={'DD/MM/YYYY'}
                    />
                    <Button type='submit' primary>{I18n.t('actions.save')}</Button>
                </Form.Group>
            </Form>
        )
    }

}

const validate = (values) => {

    const errors = {};

    if (values.discount < 0) {
        errors.discount = "El valor no puede ser menor que 0";
    }

    return errors;

};

GeneralOfferForm = connect(state => {

    const reduxFormState = _.cloneDeep(_.get(state, 'form.generalDiscountForm.values', {}));

    return {
        reduxFormState
    };

})(GeneralOfferForm);

export default reduxForm({
    form: 'generalDiscountForm',
    touchOnBlur: true,
    touchOnChange: true,
    enableReinitialize: true,
    validate
})(connect(null, { openModal, closeModal, openLoader, closeLoader })(GeneralOfferForm));